
import * as ipxRuntime$ftoSEQSXkawEkkUrnVTAbjpab8vRbibokz1dARXr6Zs from '/var/www/z_ipm/public_html/Sites_Front_End/subdomain/live/httpdocs/node_modules/.pnpm/@nuxt+image@1.10.0_@netlify+blobs@8.2.0_db0@0.3.2_ioredis@5.6.1_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 2000,
    "2xl": 2000
  },
  "presets": {},
  "provider": "ipx",
  "domains": [
    "s3.amazonaws.com",
    "old.customusb.com",
    "cdn.customusb.com",
    "www-dev2018.customusb.com",
    "www-staging2020.customusb.com",
    "www.customusb.com",
    "img.youtube.com",
    "i.vimeocdn.com"
  ],
  "alias": {
    "/youtube": "https://img.youtube.com",
    "/vimeo": "https://i.vimeocdn.com"
  },
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "webp"
  ],
  "quality": 100
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$ftoSEQSXkawEkkUrnVTAbjpab8vRbibokz1dARXr6Zs, defaults: {"maxAge":946080000,"baseURL":"/_cdn","cache":true} }
}
        